import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SupportTicketFormDialogComponent } from '../support-ticket-form-dialog/support-ticket-form-dialog.component';
import { environment } from 'environments/environment';

@Component({
  standalone: false,
  selector: 'app-support-ticket-dialog',
  templateUrl: './support-ticket-dialog.component.html',
  styleUrls: ['./support-ticket-dialog.component.scss']
})
export class SupportTicketDialogComponent {
  helpDeskConfig = environment.helpDeskConfig;
  constructor(
    private dialog : MatDialog,
    private dialogRef : MatDialogRef<SupportTicketDialogComponent>
  ) {}

  openSupportTicketFormDialog(){
    let supportForm = this.dialog.open(SupportTicketFormDialogComponent,{
      autoFocus: false,
      disableClose: true,
    });

    supportForm.afterOpened().subscribe(_ => {
      this.dialogRef.close();
    });
  }
}
